// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2F__P","comment":"styles_comment__1vzij"};